// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import infiniteScroll from 'vue-infinite-scroll'
import App from './App'
import router from './router'
import './css/element-variables.scss'
import Element from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import './css/index.scss'
import './css/en.css'
import VueI18n from 'vue-i18n'
import VueLazyload from 'vue-lazyload'
import ZHCN from '../static/lang/zh'
import ENUS from '../static/lang/en'

let LOACLE_LANG = navigator.language || navigator.userLanguage
LOACLE_LANG = LOACLE_LANG.substr(0, 2)

if (LOACLE_LANG === 'zh') {
  LOACLE_LANG = 'zh-CN'
} else {
  // require('./css/en.css');
  LOACLE_LANG = 'en-Us'
}
Vue.config.productionTip = false
Vue.use(Element, { locale })
Vue.use(infiniteScroll)
Vue.use(VueI18n)
Vue.use(VueLazyload, {
  lazyComponent: true,
  loading: 'https://www.caiyunapp.com/imgs/favorite-defulat.png',
})

const i18n = new VueI18n({
  locale: LOACLE_LANG,
  messages: {
    'zh-CN': ZHCN,
    'en-US': ENUS,
  },
})

Vue.directive('title', {
  inserted: (el, binding) => {
    document.title = el.dataset.title
  },
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>',
})


// WEBPACK FOOTER //
// ./src/main.js